import { Progress } from '@shigo-ui/ui';

import { numberFormat } from '../../../../../lib/format';
import { dashboardT } from '../../../../../lib/messages';
import { resolveLineItemCompletionPercent, type LineItem } from '../../model';

export function LineItemCompletion({ lineItem }: { lineItem: LineItem }) {
  const percent = resolveLineItemCompletionPercent(lineItem);
  return (
    <div className="grid min-w-44 gap-2">
      <div className="text-muted-foreground flex items-center justify-between gap-3 text-xs">
        <span>{numberFormat().format(lineItem.deliveredImpressions ?? 0)}</span>
        <span>{numberFormat().format(lineItem.impressionsGoal ?? 0)}</span>
      </div>
      <Progress
        value={percent}
        aria-label={dashboardT('lineItems.percentComplete', { percent: percent.toFixed(0) })}
      />
    </div>
  );
}
